module.exports = __webpack_public_path__ + "img/delete.edcfc221.svg";